<template>
  <a
    :href="href"
    :target="target"
    @click="onClick"
  >
    <i
      v-if="icon"
      :class="icon"
    />
    <slot />
  </a>
</template>

<script>
export default {
  props: {
    href: {
      type: String,
      default: '',
    },
    target: {
      type: String,
      default: '_self',
    },
    icon: {
      type: String,
    },
    customClickHandler: Function,
  },
  methods: {
    onClick(event) {
      if (this.$attrs['data-analytics-id']) {
        this.$store.dispatch('analytics/trackEvent', {
          analytics: {
            category: this.$route.name,
            action: 'click',
            label: this.$attrs['data-analytics-id'],
          },
        });
      }

      // Emit the click event regardless
      this.$emit('click', event);

      if (this.customClickHandler) {
        this.customClickHandler(event);
      }

      if (!event.defaultPrevented) {
        const preventedRefs = ['', '#', undefined];
        if (preventedRefs.includes(this.href)) {
          event.preventDefault();
        } else {
          try {
            if (this.href === '/') {
              window.location = this.href;
            } else {
              const route = this.$router.resolve(this.href);
              if (route.route.matched.length) {
                event.preventDefault();
                this.$router.push(this.href);
              }
            }
          } catch (e) {
            window.location = this.href;
          }
        }
      }
    },
  },
};
</script>

<style lang="scss">
  a:not([class]) {
    color: $--color-primary;
  }
</style>
